/**
 * @generated SignedSource<<f46968af40161631955ee54a2a9acc23>>
 * @relayHash f8e22d97b05d0a6f1ef0e01cb8f54bd3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2296c436c51d69e16111d05a939e5e15add1580982a90ee0b40799f06d7ad17

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type RealtimeUpdater992BadPatternSubscription$variables = {
  cloudId: string;
  projectId: string;
};
export type RealtimeUpdater992BadPatternSubscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RealtimeUpdater992BadPatternSubscription = {
  response: RealtimeUpdater992BadPatternSubscription$data;
  variables: RealtimeUpdater992BadPatternSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RealtimeUpdater992BadPatternSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RealtimeUpdater992BadPatternSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d2296c436c51d69e16111d05a939e5e15add1580982a90ee0b40799f06d7ad17",
    "metadata": {},
    "name": "RealtimeUpdater992BadPatternSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "9d81c06a208f03b869c307cfc8e25ce1";

export default node;
